import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "email-composer__header-left" }
const _hoisted_2 = { class: "email-composer__header-title" }
const _hoisted_3 = { class: "email-composer__header-right" }
const _hoisted_4 = { class: "email-composer__content" }
const _hoisted_5 = {
  key: 0,
  class: "email-composer__row"
}
const _hoisted_6 = { class: "email-composer__row-input" }
const _hoisted_7 = { class: "email-composer__row" }
const _hoisted_8 = { class: "email-composer__row-input" }
const _hoisted_9 = { class: "email-composer__recipients" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "email-composer__recipient-input-wrapper" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 1,
  class: "email-composer__row"
}
const _hoisted_14 = { class: "email-composer__row-input" }
const _hoisted_15 = { class: "email-composer__recipients" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 2,
  class: "email-composer__row"
}
const _hoisted_18 = { class: "email-composer__row-input" }
const _hoisted_19 = { class: "email-composer__recipients" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "email-composer__row" }
const _hoisted_22 = { class: "email-composer__row-input" }
const _hoisted_23 = {
  key: 3,
  class: "email-composer__attachments"
}
const _hoisted_24 = { class: "email-composer__attachment-name" }
const _hoisted_25 = {
  key: 0,
  class: "email-composer__attachment-size"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "email-composer__body" }
const _hoisted_28 = {
  key: 4,
  class: "email-signature-preview"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "email-composer__actions" }
const _hoisted_31 = { class: "email-composer__actions-left" }
const _hoisted_32 = { class: "email-composer__split-button" }
const _hoisted_33 = ["disabled", "aria-expanded"]
const _hoisted_34 = {
  key: 0,
  class: "email-composer__popover email-composer__popover--link"
}
const _hoisted_35 = { class: "email-composer__popover-content" }
const _hoisted_36 = { class: "email-composer__link-field-wrapper" }
const _hoisted_37 = { class: "email-composer__link-field-wrapper email-composer__link-field-wrapper--url" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "email-composer__actions-right" }
const _hoisted_41 = {
  key: 0,
  class: "email-composer__ai-buttons"
}
const _hoisted_42 = ["disabled", "title"]
const _hoisted_43 = ["disabled", "title"]
const _hoisted_44 = ["disabled", "title"]
const _hoisted_45 = ["disabled", "title"]

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
  type CSSProperties,
} from "vue";
import { useQueryClient } from "@tanstack/vue-query";
import { Icon } from "@iconify/vue";

import Button from "@/components/ui/Button.vue";
import Input from "@/components/ui/Input.vue";
import RichTextEditor from "@/components/ui/RichTextEditor.vue";
import Select from "@/components/ui/Select.vue";
import IcpPicker from "@/components/ui/IcpPicker.vue";
import ActionConfirmationModal from "@/components/modal/ActionConfirmationModal.vue";

import EmojiPicker from "./EmojiPicker.vue";
import ScheduleSendModal from "./ScheduleSendModal.vue";
import AiRefinePopover from "./AiRefinePopover.vue";

import EmailSignatureService from "@/services/email-signature";
import AIGenerationService from "@/services/ai/ai-generation";
import { getEditorHTML, getQuillInstance, isBodyEmpty } from "@/utils/emailComposerHelpers";
import { useToast } from "@/composables/ui/useToast";
import { useDraggable } from "@/composables/ui/useDraggable";

const MAX_FILE_SIZE = 5 * 1024 * 1024;

interface Account {
  id: string;
  email?: string;
  name?: string;
  accountType?: string;
}

interface Recipient {
  email: string;
  name?: string;
}

interface Icp {
  id: string;
  [key: string]: any;
}

interface Props {
  show?: boolean;
  replyTo?: any;
  replyAll?: boolean;
  forwardEmail?: any;
  defaultRecipient?: string;
  accounts?: Account[];
  defaultAccountId?: string;
  initialBody?: string;
  initialSubject?: string;
  showAiButtons?: boolean;
  isThread?: boolean;
  aiButtonsDisabled?: boolean;
  isGeneratingAI?: boolean;
  contactId?: string;
  icpId?: string;
  icps?: Icp[];
  generatingAction?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailComposer',
  props: {
    show: { type: Boolean, default: false },
    replyTo: { default: null },
    replyAll: { type: Boolean, default: false },
    forwardEmail: { default: null },
    defaultRecipient: { default: "" },
    accounts: { default: () => [] },
    defaultAccountId: { default: "" },
    initialBody: { default: "" },
    initialSubject: { default: "" },
    showAiButtons: { type: Boolean, default: false },
    isThread: { type: Boolean, default: false },
    aiButtonsDisabled: { type: Boolean, default: false },
    isGeneratingAI: { type: Boolean, default: false },
    contactId: { default: "" },
    icpId: { default: "" },
    icps: { default: () => [] },
    generatingAction: { default: null }
  },
  emits: ["close", "send", "save-draft", "schedule-send", "ai-reply", "ai-followup", "ai-compose"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const queryClient = useQueryClient();
const toast = useToast();

// State
const formData = reactive<{
  account_id: string;
  to: Recipient[];
  cc: Recipient[];
  bcc: Recipient[];
  subject: string;
  body: string;
  reply_to: string | null;
  attachments: any[];
  tracking_options: { opens: boolean; links: boolean };
}>({
  account_id: "",
  to: [],
  cc: [],
  bcc: [],
  subject: "",
  body: "",
  reply_to: null,
  attachments: [],
  tracking_options: { opens: true, links: true },
});

const recipientInput = ref("");
const ccInput = ref("");
const bccInput = ref("");
const isSending = ref(false);
const isSavingDraft = ref(false);
const showCcBcc = ref(false);
const defaultSignature = ref<any>(null);
const showLinkPopover = ref(false);
const showEmojiPopover = ref(false);
const linkUrl = ref("");
const linkText = ref("");
const showScheduleModal = ref(false);
const showScheduleMenu = ref(false);
const isScheduling = ref(false);
const showDeleteDraftModal = ref(false);
const showAiPanel = ref(false);
const showAiComposePanel = ref(false);
const isGeneratingAiCustom = ref(false);
const showIcpPicker = ref(false);
const icpPickerMode = ref<"reply" | "followup" | "compose" | null>(null);
const pendingComposeIcpId = ref<string | undefined>(undefined);

// Template refs
const richTextEditor = ref<InstanceType<typeof RichTextEditor> | null>(null);
const sendButtonRef = ref<HTMLElement | null>(null);
const linkPopoverRef = ref<HTMLElement | null>(null);
const linkInputRef = ref<HTMLInputElement | null>(null);
const aiRefineButtonRef = ref<HTMLElement | null>(null);
const aiComposeButtonRef = ref<HTMLElement | null>(null);

// Drag handling — uses shared composable
const {
  modalRef,
  isDragging,
  isInitialPosition,
  style: draggableStyle,
  startDrag,
  reset: resetPosition,
} = useDraggable({
  initialWidth: 640,
  initialHeight: 650,
  clampPadding: 16,
  excludedSelectors: [
    ".email-composer__header-btn",
    ".email-composer__content",
    ".email-composer__row",
    ".email-composer__body",
    ".email-composer__actions",
  ],
});

// Computed
const isReply = computed(() => !!props.replyTo);
const isForward = computed(() => !!props.forwardEmail);

const canSend = computed(() => {
  if (!formData.account_id || formData.to.length === 0) return false;
  const editorContent = getEditorHTML(richTextEditor.value, formData.body);
  // If the editor reports empty content, also check formData.body directly —
  // the Quill DOM may not have synced yet after a programmatic body update
  // (e.g. cue card enrichment sets formData.body before the editor re-renders).
  if (!isBodyEmpty(editorContent)) return true;
  return !isBodyEmpty(formData.body);
});

const accountOptions = computed(() =>
  props.accounts.map((account) => {
    const providerLabel = getProviderLabel(account.accountType);
    const displayName = account.email || account.name || "Unknown";
    return {
      label: `${displayName}${providerLabel ? ` (${providerLabel})` : ""}`,
      value: account.id,
    };
  })
);

const modalStyle = computed<CSSProperties>(() => {
  if (isInitialPosition.value) {
    return {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      right: "auto",
      bottom: "auto",
    };
  }
  return draggableStyle.value;
});

// Watchers
watch(
  () => props.show,
  (newVal) => {
    if (newVal) {
      nextTick(async () => {
        await loadDefaultSignature();
        initializeForm();
      });
    } else {
      resetForm();
      isScheduling.value = false;
      showScheduleModal.value = false;
      resetPosition();
    }
  },
  { immediate: true }
);

watch(showScheduleModal, (newVal) => {
  if (newVal) {
    showScheduleMenu.value = false;
  } else {
    isScheduling.value = false;
  }
});

watch(
  () => props.defaultAccountId,
  (newVal) => {
    if (newVal && !formData.account_id) {
      formData.account_id = newVal;
    }
  }
);

watch(
  () => formData.account_id,
  (newVal, oldVal) => {
    // reply_to is scoped to the account that owns the parent email. If the user
    // switches the From account, the original reply_to id will not resolve on
    // the new account and Unipile returns "parent mail could not be found".
    if (oldVal && newVal && oldVal !== newVal && formData.reply_to) {
      formData.reply_to = null;
    }
  }
);

// Lifecycle
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

// Methods
function getProviderLabel(accountType?: string): string {
  if (!accountType) return "";
  const type = accountType.toUpperCase();
  switch (type) {
    case "GOOGLE":
      return "Gmail";
    case "MICROSOFT":
    case "OUTLOOK":
      return "Microsoft Outlook";
    default:
      return "";
  }
}

function initializeForm() {
  formData.account_id =
    props.defaultAccountId || (props.accounts.length > 0 ? props.accounts[0].id : "");
  formData.to = [];
  formData.cc = [];
  formData.bcc = [];
  formData.subject = "";
  formData.body = "";
  formData.reply_to = null;
  formData.attachments = [];
  formData.tracking_options = { opens: true, links: true };
  recipientInput.value = "";
  ccInput.value = "";
  bccInput.value = "";
  showCcBcc.value = false;

  let initialBody = "";

  if (props.initialBody) {
    initialBody = props.initialBody;
    if (props.replyTo) {
      initializeReplyForm();
    } else if (props.forwardEmail) {
      initializeForwardForm();
      if (props.initialSubject) {
        formData.subject = props.initialSubject;
      }
    } else {
      if (props.initialSubject) {
        formData.subject = props.initialSubject;
      }
      if (props.defaultRecipient) {
        addRecipientFromString(props.defaultRecipient, "to");
      }
    }
  } else if (props.replyTo) {
    initializeReplyForm();
    const quotedText =
      props.replyTo.text_body || props.replyTo.body_plain || props.replyTo.body || "";
    initialBody = `<p><br></p><p>--- Original Message ---</p><p>${quotedText.replace(/\n/g, "<br>")}</p>`;
  } else if (props.forwardEmail) {
    initializeForwardForm();
    const forwardedText =
      props.forwardEmail.text_body ||
      props.forwardEmail.body_plain ||
      props.forwardEmail.body ||
      "";
    initialBody = `<p><br></p><p>--- Forwarded Message ---</p><p>${forwardedText.replace(/\n/g, "<br>")}</p>`;
  } else {
    if (props.initialSubject) {
      formData.subject = props.initialSubject;
    }
    if (props.defaultRecipient) {
      addRecipientFromString(props.defaultRecipient, "to");
    }
  }

  formData.body = initialBody;
}

function initializeReplyForm() {
  const userEmails = props.accounts
    .map((acc) => (acc.email || acc.name || "").toLowerCase())
    .filter(Boolean);

  if (props.replyAll) {
    const toRecipients = props.replyTo.to_attendees || props.replyTo.to;
    if (toRecipients) {
      const recipientsArray = Array.isArray(toRecipients) ? toRecipients : [toRecipients];
      formData.to = recipientsArray
        .map((r: any): Recipient | null => {
          const email = r.identifier || r.email;
          if (!email) return null;
          const name = r.display_name || r.name;
          return name ? { email: String(email), name: String(name) } : { email: String(email) };
        })
        .filter((r): r is Recipient => r !== null && !userEmails.includes(r.email.toLowerCase()));
    }
  } else {
    const from = props.replyTo.from_attendee || props.replyTo.from;
    if (from) {
      const senderEmail = from.identifier || from.email;
      const senderName = from.display_name || from.name;

      if (senderEmail && !userEmails.includes(senderEmail.toLowerCase())) {
        formData.to = [
          senderName
            ? { email: String(senderEmail), name: String(senderName) }
            : { email: String(senderEmail) },
        ];
      } else {
        const toRecipients = props.replyTo.to_attendees || props.replyTo.to;
        if (toRecipients) {
          const recipientsArray = Array.isArray(toRecipients) ? toRecipients : [toRecipients];
          const firstOtherRecipient = recipientsArray
            .map((r: any): Recipient | null => {
              const email = r.identifier || r.email;
              if (!email) return null;
              const name = r.display_name || r.name;
              return name ? { email: String(email), name: String(name) } : { email: String(email) };
            })
            .filter(
              (r): r is Recipient => r !== null && !userEmails.includes(r.email.toLowerCase())
            )[0];

          if (firstOtherRecipient) {
            formData.to = [firstOtherRecipient];
          }
        }
      }
    }
  }

  formData.subject = props.replyTo.subject?.startsWith("Re: ")
    ? props.replyTo.subject
    : `Re: ${props.replyTo.subject || ""}`;

  const threadEmails = Array.isArray(props.replyTo.thread_emails)
    ? props.replyTo.thread_emails
    : null;
  const latest =
    threadEmails && threadEmails.length > 0 ? threadEmails[threadEmails.length - 1] : null;
  formData.reply_to = (latest && latest.id) || props.replyTo.id;
}

function initializeForwardForm() {
  formData.to = [];
  formData.subject = props.forwardEmail.subject?.startsWith("Fwd: ")
    ? props.forwardEmail.subject
    : `Fwd: ${props.forwardEmail.subject || ""}`;
}

function resetForm() {
  formData.body = "";
  formData.attachments = [];
}

function addRecipient(field: "to" | "cc" | "bcc", inputValue: string) {
  if (!inputValue || !inputValue.trim()) return;
  addRecipientFromString(inputValue.trim(), field);
  if (field === "to") recipientInput.value = "";
  else if (field === "cc") ccInput.value = "";
  else if (field === "bcc") bccInput.value = "";
}

function addRecipientFromString(input: string, field: "to" | "cc" | "bcc") {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const parts = input.split(/[<>]/);
  let email = "";
  let name = "";

  if (parts.length > 1) {
    name = parts[0].trim();
    email = parts[1].trim();
  } else {
    const trimmed = input.trim();
    if (emailRegex.test(trimmed)) {
      email = trimmed;
    } else {
      const words = trimmed.split(/\s+/);
      email = words[words.length - 1];
      name = words.slice(0, -1).join(" ");
    }
  }

  if (email && emailRegex.test(email)) {
    const recipient: Recipient = { email };
    if (name) recipient.name = name;
    formData[field].push(recipient);
  }
}

function removeRecipient(field: "to" | "cc" | "bcc", index: number) {
  formData[field].splice(index, 1);
}

async function loadDefaultSignature() {
  try {
    const cachedSignature = queryClient.getQueryData(["defaultEmailSignature"]);
    if (cachedSignature) {
      defaultSignature.value = cachedSignature;
      return;
    }

    const response = await EmailSignatureService.getDefaultSignature();
    if (response?.data?.status && response.data.data) {
      const signatureData = response.data.data;
      if (Array.isArray(signatureData) && signatureData.length > 0) {
        defaultSignature.value = signatureData[0];
      } else if (signatureData && typeof signatureData === "object" && signatureData.content) {
        defaultSignature.value = signatureData;
      } else {
        defaultSignature.value = null;
      }
      if (defaultSignature.value) {
        queryClient.setQueryData(["defaultEmailSignature"], defaultSignature.value);
      }
    } else {
      defaultSignature.value = null;
    }
  } catch (error) {
    defaultSignature.value = null;
  }
}

function handleAttach() {
  const input = document.createElement("input");
  input.type = "file";
  input.multiple = true;
  input.accept = "*/*";
  input.onchange = (e: Event) => {
    const files = Array.from((e.target as HTMLInputElement).files || []);
    if (files.length === 0) return;
    if (!validateFiles(files)) {
      input.value = "";
      return;
    }
    formData.attachments.push(...files);
    input.value = "";
  };
  input.click();
}

function validateFiles(files: File[]): boolean {
  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      toast.error(`File "${file.name}" is too large. Maximum size is 5MB.`);
      return false;
    }
  }
  return true;
}

function removeAttachment(index: number) {
  formData.attachments.splice(index, 1);
}

function getAttachmentName(attachment: any): string {
  if (attachment instanceof File) return attachment.name;
  if (attachment && typeof attachment === "object" && attachment.name) return attachment.name;
  return String(attachment ?? "");
}

function getAttachmentSize(attachment: any): number {
  if (attachment instanceof File) return attachment.size;
  if (attachment && typeof attachment === "object" && typeof attachment.size === "number") {
    return attachment.size;
  }
  return 0;
}

function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
}

function toggleLinkPopover() {
  if (showLinkPopover.value) {
    showLinkPopover.value = false;
    return;
  }

  closeAllPopovers();

  if (richTextEditor.value) {
    const quill = getQuillInstance(richTextEditor.value);
    if (quill) {
      const range = quill.getSelection(true);
      if (range && range.length > 0) {
        const selectedText = quill.getText(range.index, range.length);
        linkText.value = selectedText.trim();
      }
    }
  }

  showLinkPopover.value = true;
  nextTick(() => {
    linkInputRef.value?.focus();
  });
}

function closeLinkPopover() {
  showLinkPopover.value = false;
  linkUrl.value = "";
  linkText.value = "";
}

function insertLink() {
  if (!linkUrl.value || linkUrl.value.trim() === "") return;

  if (!richTextEditor.value) {
    closeLinkPopover();
    return;
  }

  try {
    const quill = getQuillInstance(richTextEditor.value);
    if (!quill) {
      closeLinkPopover();
      return;
    }

    const range = quill.getSelection(true);
    if (!range) {
      closeLinkPopover();
      return;
    }

    let url = linkUrl.value.trim();
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }

    const text = linkText.value.trim() || url;

    if (range.length > 0) {
      quill.formatText(range.index, range.length, "link", url);
    } else {
      quill.insertText(range.index, text, "link", url);
      quill.setSelection(range.index + text.length);
    }

    closeLinkPopover();
  } catch (error) {
    closeLinkPopover();
  }
}

function toggleEmojiPopover() {
  if (showEmojiPopover.value) {
    showEmojiPopover.value = false;
  } else {
    closeAllPopovers();
    showEmojiPopover.value = true;
  }
}

function closeEmojiPopover() {
  showEmojiPopover.value = false;
}

function handleEmojiSelect(emoji: any) {
  if (!richTextEditor.value) {
    closeEmojiPopover();
    return;
  }

  try {
    const quill = getQuillInstance(richTextEditor.value);
    if (!quill) {
      closeEmojiPopover();
      return;
    }

    const range = quill.getSelection(true);
    const index = range ? range.index : quill.getLength() - 1;

    const emojiChar = emoji.emoji || emoji.native || emoji;
    quill.insertText(index, emojiChar);
    quill.setSelection(index + emojiChar.length);

    closeEmojiPopover();
  } catch (error) {
    closeEmojiPopover();
  }
}

function closeAllPopovers() {
  showLinkPopover.value = false;
  showEmojiPopover.value = false;
  showScheduleModal.value = false;
}

async function handleSend() {
  if (!canSend.value || isSending.value) return;

  isSending.value = true;
  try {
    await nextTick();
    const payload = getEmailPayload();
    emit("send", payload, (success: boolean = true) => {
      isSending.value = false;
      if (success) {
        formData.attachments = [];
        handleClose();
      }
    });
  } catch (error) {
    isSending.value = false;
  }
}

async function handleSaveDraft() {
  if (!formData.account_id || formData.to.length === 0) return;

  isSavingDraft.value = true;
  try {
    await nextTick();
    const htmlBody = getEditorHTML(richTextEditor.value, formData.body);

    const payload: Record<string, any> = {
      account_id: formData.account_id,
      to: formData.to,
      body: htmlBody,
    };

    if (formData.cc.length > 0) payload.cc = formData.cc;
    if (formData.bcc.length > 0) payload.bcc = formData.bcc;
    if (formData.subject) payload.subject = formData.subject;
    if (formData.reply_to) payload.reply_to = formData.reply_to;
    if (formData.attachments.length > 0) payload.attachments = formData.attachments;

    if (formData.tracking_options) {
      const tracking = formData.tracking_options as any;
      if (tracking.opens || tracking.links || tracking.open_tracking || tracking.click_tracking) {
        payload.tracking_options = {
          opens: tracking.opens ?? tracking.open_tracking ?? false,
          links: tracking.links ?? tracking.click_tracking ?? false,
        };
      }
    }

    emit("save-draft", payload);
  } catch (error) {
    // Error saving draft
  } finally {
    isSavingDraft.value = false;
  }
}

function handleDeleteDraft() {
  showDeleteDraftModal.value = true;
}

function confirmDeleteDraft() {
  showDeleteDraftModal.value = false;
  handleClose();
}

function getEmailPayload(): Record<string, any> {
  const htmlBody = getEditorHTML(richTextEditor.value, formData.body);

  const payload: Record<string, any> = {
    account_id: formData.account_id,
    to: formData.to,
    body: htmlBody,
  };

  if (formData.cc.length > 0) payload.cc = formData.cc;
  if (formData.bcc.length > 0) payload.bcc = formData.bcc;
  if (formData.subject) payload.subject = formData.subject;
  if (formData.reply_to) payload.reply_to = formData.reply_to;
  if (formData.attachments.length > 0) payload.attachments = formData.attachments;

  if (formData.tracking_options) {
    const tracking = formData.tracking_options as any;
    if (tracking.opens || tracking.links || tracking.open_tracking || tracking.click_tracking) {
      payload.tracking_options = {
        opens: tracking.opens ?? tracking.open_tracking ?? false,
        links: tracking.links ?? tracking.click_tracking ?? false,
      };
    }
  }

  return payload;
}

function toggleScheduleMenu() {
  showScheduleMenu.value = !showScheduleMenu.value;
  if (showScheduleMenu.value) {
    closeAllPopovers();
  }
}

function handleScheduleMenuClick() {
  showScheduleMenu.value = false;
  showScheduleModal.value = true;
}

function handleAiReply() {
  if (props.aiButtonsDisabled || props.isGeneratingAI) return;
  if (props.icps && props.icps.length > 1) {
    icpPickerMode.value = "reply";
    showIcpPicker.value = true;
  } else {
    emit("ai-reply", { icpId: props.icps?.[0]?.id });
  }
}

function handleAiFollowup() {
  if (props.aiButtonsDisabled || props.isGeneratingAI) return;
  if (props.icps && props.icps.length > 1) {
    icpPickerMode.value = "followup";
    showIcpPicker.value = true;
  } else {
    emit("ai-followup", { icpId: props.icps?.[0]?.id });
  }
}

function handleAiCompose() {
  if (props.aiButtonsDisabled || props.isGeneratingAI) return;
  if (props.icps && props.icps.length > 1) {
    icpPickerMode.value = "compose";
    showIcpPicker.value = true;
  } else {
    pendingComposeIcpId.value = props.icps?.[0]?.id;
    showAiPanel.value = false;
    showAiComposePanel.value = true;
  }
}

function handleIcpSelect(icpId: string) {
  const mode = icpPickerMode.value;
  showIcpPicker.value = false;
  icpPickerMode.value = null;
  if (mode === "reply") emit("ai-reply", { icpId });
  else if (mode === "followup") emit("ai-followup", { icpId });
  else if (mode === "compose") {
    pendingComposeIcpId.value = icpId;
    showAiPanel.value = false;
    showAiComposePanel.value = true;
  }
}

function toggleAiRefinePanel() {
  showAiComposePanel.value = false;
  showAiPanel.value = !showAiPanel.value;
}

function handleAiComposeGenerate(payload: { customInstructions: string }) {
  emit("ai-compose", {
    icpId: pendingComposeIcpId.value,
    customInstructions: payload.customInstructions,
  });
  showAiComposePanel.value = false;
}

function dismissIcpPicker() {
  showIcpPicker.value = false;
  icpPickerMode.value = null;
}

async function handleAiCustomizationGenerate(payload: {
  customInstructions?: string;
  attachments?: any;
}) {
  if (isGeneratingAiCustom.value) return;
  isGeneratingAiCustom.value = true;
  try {
    const currentDraft = getEditorHTML(richTextEditor.value, formData.body);
    const response = await AIGenerationService.generateRefine({
      contactId: props.contactId || "",
      icpId: props.icpId || undefined,
      channel: "email",
      currentDraft,
      currentSubject: formData.subject || undefined,
      customInstructions: payload.customInstructions || "",
      files: payload.attachments,
    });

    formData.body = response.body;
    if (response.subject) {
      formData.subject = response.subject;
    }

    nextTick(() => {
      if (richTextEditor.value) {
        try {
          const quill = getQuillInstance(richTextEditor.value);
          if (quill && quill.root) {
            quill.root.innerHTML = response.body;
          }
        } catch (err) {
          console.warn("Error updating Quill editor:", err);
        }
      }
    });

    showAiPanel.value = false;
    toast.success("Email content refined");
  } catch (error) {
    console.error("Failed to refine email content:", error);
    toast.error("Failed to refine content");
  } finally {
    isGeneratingAiCustom.value = false;
  }
}

async function handleScheduleSend(scheduleData: { scheduledAt: any }) {
  if (isScheduling.value) return;

  try {
    isScheduling.value = true;
    emit("schedule-send", {
      ...getEmailPayload(),
      scheduledAt: scheduleData.scheduledAt,
    });
  } catch (error) {
    isScheduling.value = false;
  }
}

function handleClickOutside(event: MouseEvent) {
  if (
    showLinkPopover.value &&
    linkPopoverRef.value &&
    !linkPopoverRef.value.contains(event.target as Node)
  ) {
    closeLinkPopover();
  }

  if (
    showScheduleMenu.value &&
    sendButtonRef.value &&
    !sendButtonRef.value.contains(event.target as Node)
  ) {
    showScheduleMenu.value = false;
  }
}

function handleClose() {
  emit("close");
}

__expose({ formData, richTextEditor });

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["email-composer-overlay", { 'dragging-active': !_unref(isInitialPosition) }])
      }, [
        _createElementVNode("div", {
          ref_key: "modalRef",
          ref: modalRef,
          class: _normalizeClass(["email-composer", { 'is-dragging': _unref(isDragging) }]),
          style: _normalizeStyle(modalStyle.value)
        }, [
          _createElementVNode("div", {
            class: "email-composer__header email-composer__header--draggable",
            onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(startDrag) && _unref(startDrag)(...args))),
            onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(startDrag) && _unref(startDrag)(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(isReply.value ? "Reply" : isForward.value ? "Forward" : "New Message"), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "email-composer__header-btn",
                onClick: handleClose,
                title: "Close"
              }, [
                _createVNode(_unref(Icon), { icon: "mdi:close" })
              ])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSend, ["prevent"])
            }, [
              (__props.accounts && __props.accounts.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "email-composer__row-label" }, [
                      _createElementVNode("span", null, "From"),
                      _createElementVNode("span", { class: "email-composer__required" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(Select, {
                        modelValue: formData.account_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.account_id) = $event)),
                        options: accountOptions.value,
                        size: "sm",
                        required: ""
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "email-composer__row-label" }, [
                  _createElementVNode("span", null, "To"),
                  _createElementVNode("span", { class: "email-composer__required" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.to, (recipient, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "email-composer__recipient-tag"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(recipient.name || recipient.email), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "email-composer__recipient-remove",
                          onClick: ($event: any) => (removeRecipient('to', index))
                        }, [
                          _createVNode(_unref(Icon), { icon: "mdi:close" })
                        ], 8, _hoisted_10)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((recipientInput).value = $event)),
                        type: "text",
                        class: "email-composer__recipient-input",
                        placeholder: formData.to.length > 0 ? '' : 'Recipients',
                        onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (addRecipient('to', recipientInput.value)), ["prevent"]), ["enter"])),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (addRecipient('to', recipientInput.value)))
                      }, null, 40, _hoisted_12), [
                        [_vModelText, recipientInput.value]
                      ]),
                      (!showCcBcc.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "email-composer__cc-toggle",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (showCcBcc.value = true))
                          }, " Cc Bcc "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (showCcBcc.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "email-composer__row-label" }, "Cc", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.cc, (recipient, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "email-composer__recipient-tag"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(recipient.name || recipient.email), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "email-composer__recipient-remove",
                              onClick: ($event: any) => (removeRecipient('cc', index))
                            }, [
                              _createVNode(_unref(Icon), { icon: "mdi:close" })
                            ], 8, _hoisted_16)
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ccInput).value = $event)),
                          type: "text",
                          class: "email-composer__recipient-input",
                          placeholder: "Cc",
                          onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (addRecipient('cc', ccInput.value)), ["prevent"]), ["enter"])),
                          onBlur: _cache[9] || (_cache[9] = ($event: any) => (addRecipient('cc', ccInput.value)))
                        }, null, 544), [
                          [_vModelText, ccInput.value]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showCcBcc.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "email-composer__row-label" }, "Bcc", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.bcc, (recipient, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "email-composer__recipient-tag"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(recipient.name || recipient.email), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "email-composer__recipient-remove",
                              onClick: ($event: any) => (removeRecipient('bcc', index))
                            }, [
                              _createVNode(_unref(Icon), { icon: "mdi:close" })
                            ], 8, _hoisted_20)
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((bccInput).value = $event)),
                          type: "text",
                          class: "email-composer__recipient-input",
                          placeholder: "Bcc",
                          onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (addRecipient('bcc', bccInput.value)), ["prevent"]), ["enter"])),
                          onBlur: _cache[12] || (_cache[12] = ($event: any) => (addRecipient('bcc', bccInput.value)))
                        }, null, 544), [
                          [_vModelText, bccInput.value]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "email-composer__row-label" }, "Subject", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(Input, {
                    modelValue: formData.subject,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.subject) = $event)),
                    placeholder: "Write a Subject...",
                    size: "sm"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (formData.attachments && formData.attachments.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.attachments, (attachment, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "email-composer__attachment-item"
                      }, [
                        _createVNode(_unref(Icon), { icon: "mdi:file-outline" }),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(getAttachmentName(attachment)), 1),
                        (getAttachmentSize(attachment) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(formatFileSize(getAttachmentSize(attachment))), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "email-composer__attachment-remove",
                          onClick: ($event: any) => (removeAttachment(index))
                        }, [
                          _createVNode(_unref(Icon), { icon: "mdi:close" })
                        ], 8, _hoisted_26)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(RichTextEditor, {
                  ref_key: "richTextEditor",
                  ref: richTextEditor,
                  modelValue: formData.body,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.body) = $event)),
                  height: "300px",
                  placeholder: "Compose email",
                  "hide-toolbar-items": ['link', 'image', 'video', 'formula', 'clean']
                }, null, 8, ["modelValue"])
              ]),
              (defaultSignature.value && defaultSignature.value.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", {
                      class: "email-signature-preview__content",
                      innerHTML: defaultSignature.value.content
                    }, null, 8, _hoisted_29)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "email-composer__send-wrapper",
                    ref_key: "sendButtonRef",
                    ref: sendButtonRef
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(Button, {
                        variant: "primary",
                        size: "xs",
                        icon: "mdi:send",
                        loading: isSending.value,
                        disabled: !canSend.value,
                        onClick: handleSend,
                        class: "email-composer__send-main-btn"
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode(" Send ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "email-composer__send-dropdown-btn",
                        disabled: !canSend.value,
                        onClick: _withModifiers(toggleScheduleMenu, ["stop"]),
                        title: "Schedule send",
                        "aria-expanded": showScheduleMenu.value
                      }, [
                        _createVNode(_unref(Icon), { icon: "mdi:chevron-down" })
                      ], 8, _hoisted_33)
                    ]),
                    (showScheduleMenu.value && canSend.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "email-composer__schedule-menu",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(Button, {
                            variant: "ghost",
                            size: "sm",
                            icon: "mdi:clock-outline",
                            block: "",
                            onClick: handleScheduleMenuClick,
                            class: "email-composer__schedule-menu-item"
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode(" Schedule send ", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 512),
                  _createElementVNode("button", {
                    type: "button",
                    class: "email-composer__action-icon-btn email-composer__action-icon-btn--sm",
                    onClick: handleAttach,
                    title: "Attach files"
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:paperclip" })
                  ]),
                  _createElementVNode("div", {
                    class: "email-composer__popover-wrapper",
                    ref_key: "linkPopoverRef",
                    ref: linkPopoverRef
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "email-composer__action-icon-btn email-composer__action-icon-btn--sm",
                      onClick: toggleLinkPopover,
                      title: "Insert link"
                    }, [
                      _createVNode(_unref(Icon), { icon: "mdi:link" })
                    ]),
                    (showLinkPopover.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_unref(Icon), {
                                icon: "mdi:format-align-left",
                                class: "email-composer__link-field-icon"
                              }),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((linkText).value = $event)),
                                type: "text",
                                class: "email-composer__link-input email-composer__link-input--text",
                                placeholder: "Text",
                                onKeyup: [
                                  _withKeys(insertLink, ["enter"]),
                                  _withKeys(closeLinkPopover, ["esc"])
                                ]
                              }, null, 544), [
                                [_vModelText, linkText.value]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_unref(Icon), {
                                icon: "mdi:link",
                                class: "email-composer__link-field-icon"
                              }),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((linkUrl).value = $event)),
                                type: "text",
                                class: "email-composer__link-input email-composer__link-input--url",
                                placeholder: "Type or paste a link",
                                onKeyup: [
                                  _withKeys(insertLink, ["enter"]),
                                  _withKeys(closeLinkPopover, ["esc"])
                                ],
                                ref_key: "linkInputRef",
                                ref: linkInputRef
                              }, null, 544), [
                                [_vModelText, linkUrl.value]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "email-composer__link-apply-btn",
                                onClick: insertLink,
                                disabled: !linkUrl.value || linkUrl.value.trim() === ''
                              }, " Apply ", 8, _hoisted_38)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512),
                  _createElementVNode("button", {
                    type: "button",
                    class: "email-composer__action-icon-btn email-composer__action-icon-btn--sm",
                    onClick: toggleEmojiPopover,
                    title: "Insert emoji"
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:emoticon-outline" })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "email-composer__action-icon-btn",
                    onClick: handleSaveDraft,
                    disabled: isSavingDraft.value,
                    title: "Save draft"
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:content-save-outline" })
                  ], 8, _hoisted_39),
                  _createElementVNode("button", {
                    type: "button",
                    class: "email-composer__action-icon-btn",
                    onClick: handleDeleteDraft,
                    title: "Delete draft"
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:delete-outline" })
                  ])
                ]),
                _createVNode(IcpPicker, {
                  show: showIcpPicker.value,
                  mode: icpPickerMode.value,
                  icps: __props.icps,
                  class: "email-composer__icp-picker-positioned",
                  onSelect: handleIcpSelect,
                  onDismiss: dismissIcpPicker
                }, null, 8, ["show", "mode", "icps"]),
                _createElementVNode("div", _hoisted_40, [
                  (__props.showAiButtons)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("button", {
                          ref_key: "aiComposeButtonRef",
                          ref: aiComposeButtonRef,
                          type: "button",
                          class: "email-composer__ai-btn email-composer__ai-btn--compose",
                          disabled: __props.aiButtonsDisabled || __props.isGeneratingAI,
                          title: __props.isGeneratingAI ? 'Generating...' : 'AI Compose',
                          onClick: _withModifiers(handleAiCompose, ["stop"])
                        }, [
                          (__props.isGeneratingAI && __props.generatingAction === 'compose')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "email-composer__ai-spinner" }, null, -1)),
                                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "Generating...", -1))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "AI Compose", -1))
                              ], 64))
                        ], 8, _hoisted_42),
                        (__props.isThread)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "email-composer__ai-btn email-composer__ai-btn--reply",
                              disabled: __props.aiButtonsDisabled || __props.isGeneratingAI,
                              title: __props.isGeneratingAI ? 'Generating...' : 'AI Reply',
                              onClick: _withModifiers(handleAiReply, ["stop"])
                            }, [
                              (__props.isGeneratingAI && __props.generatingAction === 'reply')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "email-composer__ai-spinner" }, null, -1)),
                                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "Generating...", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "AI Reply", -1))
                                  ], 64))
                            ], 8, _hoisted_43))
                          : _createCommentVNode("", true),
                        (__props.isThread)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "email-composer__ai-btn email-composer__ai-btn--followup",
                              disabled: __props.aiButtonsDisabled || __props.isGeneratingAI,
                              title: __props.isGeneratingAI ? 'Generating...' : 'AI Follow-up',
                              onClick: _withModifiers(handleAiFollowup, ["stop"])
                            }, [
                              (__props.isGeneratingAI && __props.generatingAction === 'followup')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "email-composer__ai-spinner" }, null, -1)),
                                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "Generating...", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                    _cache[37] || (_cache[37] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "AI Follow-up", -1))
                                  ], 64))
                            ], 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          ref_key: "aiRefineButtonRef",
                          ref: aiRefineButtonRef,
                          type: "button",
                          class: "email-composer__ai-btn email-composer__ai-btn--custom",
                          disabled: __props.aiButtonsDisabled || __props.isGeneratingAI || isGeneratingAiCustom.value,
                          title: isGeneratingAiCustom.value ? 'Generating...' : 'AI Refine',
                          onClick: _withModifiers(toggleAiRefinePanel, ["stop"])
                        }, [
                          _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "email-composer__ai-btn-text" }, "AI Refine", -1))
                        ], 8, _hoisted_45)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 32)
          ]),
          (showEmojiPopover.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "email-composer__emoji-container",
                onClick: _withModifiers(closeEmojiPopover, ["self"])
              }, [
                _createVNode(EmojiPicker, { onSelect: handleEmojiSelect })
              ]))
            : _createCommentVNode("", true),
          (__props.showAiButtons)
            ? (_openBlock(), _createBlock(AiRefinePopover, {
                key: 1,
                show: showAiPanel.value,
                "trigger-el": aiRefineButtonRef.value,
                disabled: isGeneratingAiCustom.value,
                onGenerate: handleAiCustomizationGenerate,
                onClose: _cache[18] || (_cache[18] = ($event: any) => (showAiPanel.value = false))
              }, null, 8, ["show", "trigger-el", "disabled"]))
            : _createCommentVNode("", true),
          (__props.showAiButtons)
            ? (_openBlock(), _createBlock(AiRefinePopover, {
                key: 2,
                show: showAiComposePanel.value,
                "trigger-el": aiComposeButtonRef.value,
                disabled: __props.isGeneratingAI && __props.generatingAction === 'compose',
                title: "AI Compose",
                "generate-button-label": "Generate Message",
                "show-attachments": false,
                onGenerate: handleAiComposeGenerate,
                onClose: _cache[19] || (_cache[19] = ($event: any) => (showAiComposePanel.value = false))
              }, null, 8, ["show", "trigger-el", "disabled"]))
            : _createCommentVNode("", true)
        ], 6),
        _createVNode(ScheduleSendModal, {
          show: showScheduleModal.value,
          "is-loading": isScheduling.value,
          onClose: _cache[20] || (_cache[20] = ($event: any) => (showScheduleModal.value = false)),
          onSchedule: handleScheduleSend
        }, null, 8, ["show", "is-loading"]),
        _createVNode(ActionConfirmationModal, {
          show: showDeleteDraftModal.value,
          title: "Delete Draft",
          message: "Are you sure you want to delete this draft? This action cannot be undone.",
          "confirm-text": "Delete",
          "cancel-text": "Cancel",
          icon: "mdi:delete-outline",
          onConfirm: confirmDeleteDraft,
          onClose: _cache[21] || (_cache[21] = ($event: any) => (showDeleteDraftModal.value = false))
        }, null, 8, ["show"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})